<template>
  <div style="max-height: 400px;overflow-y: auto" v-loading="loading">
    <div style="height: 10px"></div>
    <div v-if="phonelist.length === 0" style="height: 150px;line-height: 150px;font-size: 20px;text-align: center">
      <span>暂无电话</span>
    </div>
    <div v-else style="max-height: 300px;overflow-y: auto;">
      <div class="box-card" v-for="item in phonelist" :key="item.id">
        <div class="img-left">
          <img :src="getSrcUri(item.uri)"/>
        </div>
        <div class="body-center">
          <div style="height: 15px"></div>
          <div style="height: 30px;font-size: 20px;color: #333333">
            <span>{{item.name}}</span>
          </div>
          <div style="height: 20px;color: #666666">
            <span>
              <img style="vertical-align: text-top;" src="../../../assets/tel/telephone_phone.png">
              <span>{{item.phone}}</span>
            </span>
          </div>
          <div style="height: 20px;color: #666666">
            <span>
              <img style="vertical-align: text-top;" src="../../../assets/tel/telephone_im.png">
              <span>{{item.im_num}}</span>
            </span>
          </div>
        </div>
        <div class="btn-right">
          <el-row>
            <el-col :span="12">
              <div class="del-sub-red" @click="delTel(item)">
                <el-row>
                  <el-col :span="10" style="height: 30px;text-align: right">
                    <img style="margin-top: 6px" src="../../../../static/subDevice/son_btn_delete.png">
                  </el-col>
                  <el-col :span="14" style="height: 30px;line-height: 30px;color: white">
                    <span style="margin-left: 5px">删除</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="edit-sub-blue" @click="editTel(item)">
                <el-row>
                  <el-col :span="10" style="height: 30px;text-align: right">
                    <img style="margin-top: 6px" src="../../../../static/subDevice/son_btn_edit.png">
                  </el-col>
                  <el-col :span="14" style="height: 30px;line-height: 30px;color: white">
                    <span style="margin-left: 5px">编辑</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addEditShow"
      v-if="addEditShow"
      width="650px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      append-to-body
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>{{titleShow}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <add-edit-tel :addEditObj="addEditObj" v-model="addEditShow" @getFather="getDevicePhoneBook"></add-edit-tel>
    </el-dialog>
  </div>
</template>

<script>
import addEditTel from './addEditTel'
import {querydevicephonebook, deletedevicephonebook} from '../../../api/device'
// import {queryfamilyperson} from '../../../api/serviceObject'
import {queryfamilypersonbyhid} from '../../../api/organizer'

export default {
  name: 'telBook',
  model: {
    prop: 'telShow',
    event: 'change'
  },
  props: {
    telObj: {
      type: Object
    }
  },
  components: {addEditTel},
  data () {
    return {
      loading: false,
      titleShow: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        oldpersons: [],
        device: '',
        row: ''
      },
      device: '',
      phonelist: []
    }
  },
  created () {
    console.log(this.telObj)
    this.device = this.telObj
    this.addEditObj.device = this.device
    this.getFamily()
    this.getDevicePhoneBook()
  },
  methods: {
    // 查询联系人
    getFamily () {
      let data = {
        orgid: this.device.oid,
        hid: this.device.hid
      }
      queryfamilypersonbyhid(data).then(res => {
        this.addEditObj.oldpersons = res.data.familypersons
      }).catch(() => {})
    },
    getDevicePhoneBook () {
      this.loading = true
      let data = {
        did: this.device.id
      }
      querydevicephonebook(data).then(res => {
        this.loading = false
        this.phonelist = res.data.phonelist
      }).catch(() => {
        this.loading = false
      })
    },
    getSrcUri (uri) {
      let url = 'static/head.png'
      let arr = ['.png', '.jpg', '.jpeg']
      for (let i = 0; i < arr.length; i++) {
        if (uri.includes(arr[i])) {
          url = uri
        }
      }
      return url
    },
    addTel () {
      this.addEditObj.isAdd = true
      this.titleShow = '添加电话'
      this.addEditShow = true
    },
    delTel (item) {
      let name = item.name
      this.$confirm('此操作将永久删除该【' + name + '】白名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          phonelistids: [item.id],
          imei: this.device.deviceid
        }
        deletedevicephonebook(data).then(res => {
          this.getDevicePhoneBook()
          this.$notify({
            title: '成功',
            message: '删除白名单',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    editTel (item) {
      this.addEditObj.isAdd = false
      this.addEditObj.row = item
      this.titleShow = '编辑电话'
      this.addEditShow = true
    }
  }
}
</script>

<style scoped>
.add-btn{
  width: 90px;
  height: 35px;
  line-height: 35px;
  border-radius: 10px;
  border: solid 2px #00aaff;
  color: #00aaff;
  font-size: 20px;
  cursor: pointer;
  text-align: center;
}
.add-btn:hover{
  background-color: #00aaff;
  color: white;
}
  .box-card{
    height: 100px;
  }
.box-card:hover{
  background-color: #f2fafa;
  border-radius: 6px;
}
.img-left{
  float: left;
  height: 100%;
  width: 100px;
}
.img-left img{
  width: 60px;
  height: 60px;
  margin-left: 20px;
  margin-top: 20px;
}
.body-center{
  float: left;
  height: 100%;
  width: calc(100% - 370px);
}
.body-center img{
  width: 16px;
  height: 16px;
}
.btn-right{
  float: right;
  height: 100%;
  width: 260px;
}
.del-sub-red{
  cursor: pointer;
  margin-top: 35px;
  width: 100px;
  height: 30px;
  background-image: linear-gradient(0deg,
  #e50000 0%,
  #ff7f7f 100%);
  border-radius: 15px;
}
.edit-sub-blue{
  cursor: pointer;
  margin-top: 35px;
  width: 100px;
  height: 30px;
  background-image: linear-gradient(0deg,
  #1786fc 0%,
  #7ebbfc 100%);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/telBook.vue